import { Reducer } from 'redux';
import { IAction } from '../types';
import { listJson } from './service';
import { allLabelJson } from '@/views/system/rankings/server';
import LocalStore from '@/utils/store';

export interface sdobj {
  groupId?: number | undefined;
  title: string;
  child: allLabelJson[];
  labelId?: number;
}

export interface BaseInfoState {
  versionList: listJson[];
  tagList: listJson[];
  tagLists: listJson[];
  rankTagList: sdobj[];
  rankTagRawList: listJson[];
  isBackTop: boolean;
  isBackTopReturn: boolean;
  tagNameMap: {};
}

const localGameInfo = LocalStore.getValue<BaseInfoState>('BASE_INFO_DATA') || {};

export const baseInfo: BaseInfoState = {
  versionList: [],
  tagList: [],
  tagLists: [],
  rankTagList: [],
  rankTagRawList: [],
  isBackTop: false,
  isBackTopReturn: false,
  tagNameMap: {},
  ...localGameInfo
};

export const setBaseInfoData: (payload: BaseInfoState) => IAction<BaseInfoState> = (payload: BaseInfoState) => ({
  type: 'setBaseInfoData',
  payload
});

const baseDataReducer: Reducer<BaseInfoState, IAction<any>> = (state = baseInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setBaseInfoData':
      LocalStore.setValue('BASE_INFO_DATA', payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default baseDataReducer;
